@use "../../../../../styles/Colors.scss" as Colors;
@use "../../../../../styles/Constants.scss" as Constants;

.empty-time-sheet {
	padding-bottom: Constants.$val-headerHeight;
	background-color: Colors.$col-white;
	padding: Constants.$val-spacing-m;
	color: Colors.$col-grey;
	font-style: italic;
}

.banner {
	padding: Constants.$val-spacing-l;
	background: Colors.$col-greyInactive;
	color: Colors.$col-white;
	font-weight: bold;
}